import type { MfgMaterial } from "@/lib/manufacturingClient";
import type { MfgPurchaseOrder } from "@/lib/manufacturing/purchaseOrderClient";
import type { PoDraftLine } from "@/components/manufacturing/purchaseOrderDraftState";
import { GeneratePurchaseOrderSaveBar } from "@/components/manufacturing/GeneratePurchaseOrderSaveBar";
import { isPlantMaterialRequest } from "@/lib/manufacturing/plantMaterialRequest";

export function GeneratePurchaseOrderFooter(props: {
  materials: MfgMaterial[];
  plantId: string;
  lines: PoDraftLine[];
  onLines: (lines: PoDraftLine[]) => void;
  confirmation: string;
  setConfirmation: (v: string) => void;
  ccEmails: string[];
  setCcEmails: (v: string[]) => void;
  enabled: boolean;
  busy: boolean;
  readOnlyHeader: boolean;
  hasIssuedActive: boolean;
  msg: { text: string; ok: boolean } | null;
  onMsg: (msg: { text: string; ok: boolean }) => void;
  onSaveDraft: () => void;
  onIssueAndPdf: () => void;
  onFinalize: () => void;
  canFinalize: boolean;
  finalized: boolean;
  canIssue: boolean;
  active: MfgPurchaseOrder | null;
  expectedDeliveryOn: string;
  onExpectedDeliveryOn: (v: string) => void;
  onAcknowledge: () => void;
}) {
  const plantRequest = props.active ? isPlantMaterialRequest(props.active) : false;
  return (
    <>
      <GeneratePurchaseOrderSaveBar
        materials={props.materials}
        plantId={props.plantId}
        lines={props.lines}
        onLines={props.onLines}
        confirmation={props.confirmation}
        setConfirmation={props.setConfirmation}
        ccEmails={props.ccEmails}
        setCcEmails={props.setCcEmails}
        enabled={props.enabled}
        busy={props.busy}
        readOnlyHeader={props.readOnlyHeader}
        hasIssuedActive={props.hasIssuedActive}
        msg={props.msg}
        onMsg={props.onMsg}
        onSaveDraft={props.onSaveDraft}
        onIssueAndPdf={props.onIssueAndPdf}
        onFinalize={props.onFinalize}
        canFinalize={props.canFinalize}
        finalized={props.finalized}
        canIssue={props.canIssue}
        isPlantRequest={plantRequest}
        acknowledged={Boolean(props.active?.acknowledged_at)}
        expectedDeliveryOn={props.expectedDeliveryOn}
        onExpectedDeliveryOn={props.onExpectedDeliveryOn}
        onAcknowledge={props.canIssue ? props.onAcknowledge : undefined}
      />
    </>
  );
}
